function markMediaLoading(root) {
  root = root || document;
  var images = root.querySelectorAll ? root.querySelectorAll('.media > img') : [];

  images.forEach(function (img) {
    var media = img.closest('.media');
    if (!media || media.dataset.shimmerBound) return;
    media.dataset.shimmerBound = 'true';

    if (img.complete && img.naturalWidth > 0) return;

    media.classList.add('media--loading');
    var clear = function () {
      media.classList.remove('media--loading');
    };
    img.addEventListener('load', clear, { once: true });
    img.addEventListener('error', clear, { once: true });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  markMediaLoading(document);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.media')) {
          markMediaLoading(node.parentElement || document);
        } else if (node.querySelectorAll) {
          markMediaLoading(node);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
